module.exports = __webpack_public_path__ + "static/media/5a1ac58cf65d84088faf133d.382ff772.png";